import { useMemo } from 'react';
import { PeriodUnit, Period } from 'components/CustomRepeatEvery/CustomRepeatEvery';

const useBasics = (period: Period, periodicity: string, selectedPeriod: PeriodUnit): [number] => {
	const numberOfOrders: number = useMemo(() => {
		const { startDate, endDate } = period;

		if (endDate && periodicity) {
			switch (selectedPeriod) {
				case PeriodUnit.DAY:
					if (endDate.diff(startDate, 'days') === 0) {
						return 1;
					} else {
						return Math.floor(endDate.diff(startDate, 'days') / Number(periodicity));
					}
				case PeriodUnit.WEEK:
					if (endDate.diff(startDate, 'weeks') === 0) {
						return 1;
					} else {
						return Math.floor(endDate.diff(startDate, 'weeks') / Number(periodicity));
					}
				case PeriodUnit.MONTH:
					if (endDate.diff(startDate, 'months') === 0) {
						return 1;
					} else {
						return Math.floor(endDate.diff(startDate, 'months') / Number(periodicity));
					}
				case PeriodUnit.YEAR:
					if (endDate.diff(startDate, 'years') === 0) {
						return 1;
					} else {
						return Math.floor(endDate.diff(startDate, 'years') / Number(periodicity));
					}
				default:
					return 1;
			}
		} else {
			return 1;
		}
	}, [selectedPeriod, periodicity, period]);

	return [numberOfOrders];
};

export default useBasics;
